import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BannerHeroDesktop1 from "../../../assets/images/banner/banner-4.jpeg";
import BannerMobile1 from "../../../assets/images/banner/banner-mobile-3.jpeg";
import BannerHeroDesktop2 from "../../../assets/images/banner/banner-1.jpeg";
import BannerMobile2 from "../../../assets/images/banner/banner-mobile-1.jpeg";
import BannerHeroDesktop3 from "../../../assets/images/banner/banner-2.jpeg";
import BannerMobile3 from "../../../assets/images/banner/banner-mobile-2.jpeg";
import BannerHeroDesktop4 from "../../../assets/images/banner/banner-6.jpeg";
import BannerMobile4 from "../../../assets/images/banner/banner-mobile-4.jpeg";
import BannerHeroDesktop5 from "../../../assets/images/banner/banner-7.jpeg";
import BannerMobile5 from "../../../assets/images/banner/banner-7.jpeg";

export default function Hero() {
    const slides = [
        { desktop: BannerHeroDesktop5, mobile: BannerMobile5 },
        { desktop: BannerHeroDesktop1, mobile: BannerMobile1 },
        { desktop: BannerHeroDesktop2, mobile: BannerMobile2 },
        { desktop: BannerHeroDesktop3, mobile: BannerMobile3 },
        { desktop: BannerHeroDesktop4, mobile: BannerMobile4 },
    ];
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);
        return () => clearInterval(timer);
    }, [slides.length]);

    const { t } = useTranslation();
    const raceDate = new Date("2026-09-13T05:00:00");
    const [countdown, setCountdown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            const distance = raceDate - now;

            if (distance < 0) {
                clearInterval(interval);
                setCountdown({
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0,
                });
                return;
            }

            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            setCountdown({ days, hours, minutes, seconds });
        }, 1000);

        return () => clearInterval(interval);
    }, [raceDate]);
    return (
        <div className="w-full min-h-screen relative overflow-hidden bg-brand-blue">
            <div className="absolute inset-0 z-0 select-none pointer-events-none">
                {slides.map((slide, idx) => (
                    <div
                        key={idx}
                        className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${idx === currentSlide ? "opacity-100 z-10" : "opacity-0 z-0"
                            }`}
                    >
                        <picture>
                            <source media="(max-width: 768px)" srcSet={slide.mobile} />
                            <img
                                src={slide.desktop}
                                alt={`Tangerang 10K Banner ${idx + 1}`}
                                className="w-full h-full object-cover"
                                fetchPriority={idx === 0 ? "high" : "low"}
                                loading={idx === 0 ? "eager" : "lazy"}
                            />
                        </picture>
                        <div className="absolute inset-0 bg-black/25" />
                    </div>
                ))}
            </div>

            <div className="container mx-auto w-full relative h-screen px-6 md:px-12 lg:px-16 xl:px-24 flex items-end pb-24 justify-center lg:justify-start z-20">
                <div className="w-full max-w-[340px] sm:max-w-md lg:max-w-[450px] xl:max-w-[500px] flex flex-wrap lg:text-left text-center">
                    <div className="basis-full bg-brand-orange rounded-t-lg shadow-lg">
                        <div className="font-evil">
                            <div className="px-4 py-2 w-full text-center">
                                <p className="2xl:text-4xl xl:text-3xl lg:text-2xl md:text-2xl text-xl text-white tracking-wide">
                                    {t("hero.date")}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="w-full pt-4 rounded-b-lg">
                        <div className="grid grid-cols-4 gap-2 md:gap-3 lg:gap-4 font-evil">
                            <div className="text-center bg-white/90 backdrop-blur-md px-1 py-3 rounded-lg shadow-lg border border-white/20">
                                <h2 className="2xl:text-5xl xl:text-4xl lg:text-3xl text-2xl font-evil font-black text-center text-brand-blue">
                                    {countdown.days}
                                </h2>
                                <p className="font-light xl:text-base lg:text-sm text-[10px] text-center text-brand-blue uppercase tracking-wider mt-1">
                                    {t("hero.day")}
                                </p>
                            </div>
                            <div className="text-center bg-white/90 backdrop-blur-md px-1 py-3 rounded-lg shadow-lg border border-white/20">
                                <h2 className="2xl:text-5xl xl:text-4xl lg:text-3xl text-2xl font-evil font-black text-center text-brand-blue">
                                    {countdown.hours}
                                </h2>
                                <p className="font-light xl:text-base lg:text-sm text-[10px] text-center text-brand-blue uppercase tracking-wider mt-1">
                                    {t("hero.hour")}
                                </p>
                            </div>
                            <div className="text-center bg-white/90 backdrop-blur-md px-1 py-3 rounded-lg shadow-lg border border-white/20">
                                <h2 className="2xl:text-5xl xl:text-4xl lg:text-3xl text-2xl font-evil font-black text-center text-brand-blue">
                                    {countdown.minutes}
                                </h2>
                                <p className="font-light xl:text-base lg:text-sm text-[10px] text-center text-brand-blue uppercase tracking-wider mt-1">
                                    {t("hero.minutes")}
                                </p>
                            </div>
                            <div className="text-center bg-white/90 backdrop-blur-md px-1 py-3 rounded-lg shadow-lg border border-white/20">
                                <h2 className="2xl:text-5xl xl:text-4xl lg:text-3xl text-2xl font-evil font-black text-center text-brand-blue">
                                    {countdown.seconds}
                                </h2>
                                <p className="font-light xl:text-base lg:text-sm text-[10px] text-center text-brand-blue uppercase tracking-wider mt-1">
                                    {t("hero.seconds")}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2.5 z-20">
                {slides.map((_, idx) => (
                    <button
                        key={idx}
                        onClick={() => setCurrentSlide(idx)}
                        className={`w-3.5 h-3.5 rounded-full transition-all duration-300 shadow-md ${idx === currentSlide ? "bg-brand-orange w-8" : "bg-white/60 hover:bg-white"
                            }`}
                        aria-label={`Go to slide ${idx + 1}`}
                    />
                ))}
            </div>
        </div>
    );
}
